import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { IconsLoader } from "../../imports/icon";
import useGameScore from "../../customHooks/useScore";
import PhoneScreen from "../Auth/LogInModal";
import useCheckSubscription from "../../customHooks/useSubscriptionCheck";
import useSaveHighScore from "../../customHooks/useSaveHighScore";

const Overlay = ({ isVisible, onClose, children, type, scores }) => {
  if (type === "subscribe" && isVisible) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
        <div className="relative p-6 rounded-lg shadow-lg">{children}</div>
      </div>
    );
  } else if (type !== "subscribe" && isVisible) {
    if (parseInt(type) < scores) {
      return null;
    } else {
      return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="relative p-6 rounded-lg shadow-lg">{children}</div>
        </div>
      );
    }
  }
};

export default function Index({ url, paymentType, gameName, withHistory }) {
  const user = useSelector((state) => state.user);
  const language = useSelector((state) => state.lang.language);
  const iframeRef = useRef(null);
  const [hasOpendSMS, setHasOpendSMS] = useState(false);
  const { scores, isLoadingSet } = useGameScore(user.value?.phone, gameName);
  const [error, setError] = useState(false);

  const { isSubscribed, isNotSubscribed, isNotLoggedIn, loading } =
    useCheckSubscription(user?.value?.phone);

  const { saveHighScore, errorsaving, loadingsaving, response } =
    useSaveHighScore();

  const testURL = url;

  const handleMessageFromIframe = useCallback(
    (event) => {
      if (event.origin !== 'https://kinet-games-weraj.web.app') {
        console.log("found some error with the domain");
        return;
      }

      const iframeWindow = iframeRef.current?.contentWindow;
      if (event.data === "give me tournament data") {
        if (iframeWindow) {
          iframeWindow.postMessage(scores, testURL);
        }
        return;
      }

      if (typeof event.data === "string") {
        let parsedData;
        try {
          parsedData = JSON.parse(event.data);
          console.log("\x1b parsed data", parsedData);
        } catch (e) {
          console.error("Error parsing data", e);
          return;
        }

        const safeLevel = parsedData?.level ?? 1;
        const safeScore = parsedData?.score ?? 1;

        // if (safeLevel > 3 && isNotSubscribed) return;

        saveHighScore(
          user?.value?.phone,
          gameName,
          safeLevel,
          safeScore,
          withHistory
        );
      }
    },
    [
      testURL,
      iframeRef,
      scores,
      user?.value?.phone,
      gameName,
      withHistory,
      isNotSubscribed,
    ]
  );
  
  const event = ({ action, category, label, value }) => {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  };

  const subscriberNew = async () => {
    if (isSubscribed) {
      event({
        action: "subscribe",
        category: "user trying to play a new",
        label: "logged in user",
        value: "clicked on subscrie after loading the game",
      });
    } else {
      newDataIs();
      event({
        action: "subscribe",
        category: "user trying to play a new",
        label: "logged in user",
        value: "clicked on subscrie after loading the game",
      });
    }
  };

  const awaitBrowserResponse = () => {
    document.addEventListener(
      "visibilitychange",
      function () {
        if (document.hidden) {
          setHasOpendSMS(true);
        }
      },
      false
    );
  };

  const newDataIs = () => {
    window.location.href = "sms:9871?body=ok";
    awaitBrowserResponse();
  };


  useEffect(() => {
    window.addEventListener("message", handleMessageFromIframe);
    return () => {
      window.removeEventListener("message", handleMessageFromIframe);
    };
  }, [isLoadingSet]);


  return (
    <div>
      <a href="/" className="fixed top-2 left-5">
        <IconsLoader icon="close" width={30} />
      </a>
      {!user.isLogedIn && (
        <Overlay isVisible={!isSubscribed} type={paymentType} scores={scores}>
          <div className="flex flex-col justify-center items-center min-h-[100vh]">
            <a
              onClick={() => subscriberNew()}
              className="md:text-xl font-milkb text-center text-white"
            >
              {language.subscirbeToPlayMore}
            </a>
            {!isSubscribed ? (
              <div className="flex justify-center w-[100%]  mt-5 rounded-lg bg-[#242C37] py-10 px-10">
                <PhoneScreen />
              </div>
            ) : null}
          </div>
        </Overlay>
      )}

      <div className="bg-black pt-0">
        {isLoadingSet ? (
          <iframe
            src={testURL}
            ref={iframeRef}
            title="Godot Game"
            className="w-full h-[100vh] p-0 bg-black"
            allowFullScreen
          />
        ) : (
          <div className="flex flex-col justify-center items-center min-h-[100vh]">
            <div role="status">
              <svg
                aria-hidden="true"
                class="inline w-14 h-20 text-gray-200 animate-spin dark:text-gray-600 fill-[#FE9902]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
            <h1 className="py-2 text-white">Loading Game</h1>
          </div>
        )}
      </div>
    </div>
  );
}
